import { render, staticRenderFns } from "./TicketImagesForm.vue?vue&type=template&id=6ec8a06f&"
import script from "./TicketImagesForm.vue?vue&type=script&lang=ts&"
export * from "./TicketImagesForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports